<template>
  <VText small class="form-label" :class="{
    'form-label--required': required,
    'form-label--invalid': invalid,
  }">
    <slot />
  </VText>
</template>

<script>
export default {
  name: 'VFormLabel',

  props: {
    required: {
      type: Boolean,
      default: false,
    },

    invalid: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.form-label {
  &--invalid.text {
    color: $formLabelInvalidColor;
  }

  &--required::before {
    content: '*';

    margin-right: 0.25em;

    font-weight: 900;
    color: $formRequiredColor;
  }
}
</style>
